import { render, staticRenderFns } from "./MainStaffSelect.vue?vue&type=template&id=575ffbbf"
import script from "./MainStaffSelect.vue?vue&type=script&lang=js"
export * from "./MainStaffSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports